import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixEventsTicketingTicketManagementUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www.wixapis.com': [
      {
        srcPath: '/events/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/events/v2/ticket-definitions',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/events/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/events/v2/ticket-definitions',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v2/ticket-definitions',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/events-ticketing-v1-proxy',
        destPath: '/api',
      },
    ],
    _: [
      {
        srcPath: '/_api/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v2/ticket-definition',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/events-ticketing-v1-proxy/v1',
        destPath: '/v1',
      },
      {
        srcPath: '/_api/events-ticketing-v1-proxy/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v2/ticket-definitions',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v2/ticket-definitions',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v2/ticket-definitions',
        destPath: '/v2/ticket-definitions',
      },
      {
        srcPath: '/_api/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
    ],
    '*.pub.wix-code.com': [
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'api._base_domain_': [
      {
        srcPath: '/events/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/events/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/events/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/events/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/events/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'editor-flow.wixapps.net': [
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/wix-events-web/v1/tickets',
        destPath: '/v1/tickets',
      },
      {
        srcPath: '/_api/wix-events-web/v1/checkout',
        destPath: '/v1/checkout',
      },
      {
        srcPath: '/_api/wix-events-web/v1/ticket-definitions',
        destPath: '/v1/ticket-definitions',
      },
      {
        srcPath: '/_api/wix-events-web/v1/tickets/available',
        destPath: '/v1/tickets/available',
      },
      {
        srcPath: '/_api/wix-events-web/v1/pos-checkout',
        destPath: '/v1/pos-checkout',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_events_tickets';

/**
 * Retrieves a list of up to 100 tickets.
 *
 * <!--
 * >**Note:** This function is restricted and only runs if you elevate permissions using the [wix-auth.elevate()](https://www.wix.com/velo/reference/wix-auth/elevate) function.
 * -->
 */
export function listTickets(payload: object): RequestOptionsFactory<any> {
  function __listTickets({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket',
      method: 'GET' as any,
      methodFqn: 'wix.events.ticketing.TicketManagement.ListTickets',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingTicketManagementUrl({
        protoPath: '/v1/tickets',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'tickets.checkIn.created' },
              { path: 'tickets.checkIn.checkInCanceledDate' },
              { path: 'tickets.guestDetails.form.inputValues.dateTime' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'tickets.guestDetails.form.inputValues.number' },
              {
                path: 'tickets.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'tickets.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
      fallback: [
        {
          method: 'GET' as any,
          url: resolveWixEventsTicketingTicketManagementUrl({
            protoPath: '/v1/tickets',
            data: payload,
            host,
          }),
          params: toURLSearchParams(payload),
        },
      ],
    };

    return metadata;
  }

  return __listTickets;
}

/** Retrieves a ticket by the unique ticket number. */
export function getTicket(payload: object): RequestOptionsFactory<any> {
  function __getTicket({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket',
      method: 'GET' as any,
      methodFqn: 'wix.events.ticketing.TicketManagement.GetTicket',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingTicketManagementUrl({
        protoPath: '/v1/tickets/{ticketNumber}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'ticket.checkIn.created' },
              { path: 'ticket.checkIn.checkInCanceledDate' },
              { path: 'ticket.guestDetails.form.inputValues.dateTime' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'ticket.guestDetails.form.inputValues.number' },
              {
                path: 'ticket.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'ticket.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
      fallback: [
        {
          method: 'GET' as any,
          url: resolveWixEventsTicketingTicketManagementUrl({
            protoPath: '/v1/tickets/{ticketNumber}',
            data: payload,
            host,
          }),
          params: toURLSearchParams(payload),
        },
      ],
    };

    return metadata;
  }

  return __getTicket;
}

/** Checks in 1 or more tickets. */
export function checkInTicket(payload: object): RequestOptionsFactory<any> {
  function __checkInTicket({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket',
      method: 'POST' as any,
      methodFqn: 'wix.events.ticketing.TicketManagement.CheckInTicket',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingTicketManagementUrl({
        protoPath: '/v1/tickets/check-in',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'tickets.checkIn.created' },
              { path: 'tickets.checkIn.checkInCanceledDate' },
              { path: 'tickets.guestDetails.form.inputValues.dateTime' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'tickets.guestDetails.form.inputValues.number' },
              {
                path: 'tickets.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'tickets.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __checkInTicket;
}

/** Deletes check-ins for 1 or more tickets. */
export function deleteTicketCheckIn(
  payload: object
): RequestOptionsFactory<any> {
  function __deleteTicketCheckIn({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket',
      method: 'DELETE' as any,
      methodFqn: 'wix.events.ticketing.TicketManagement.DeleteTicketCheckIn',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingTicketManagementUrl({
        protoPath: '/v1/tickets/check-in',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'tickets.checkIn.created' },
              { path: 'tickets.checkIn.checkInCanceledDate' },
              { path: 'tickets.guestDetails.form.inputValues.dateTime' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'tickets.guestDetails.form.inputValues.number' },
              {
                path: 'tickets.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'tickets.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __deleteTicketCheckIn;
}

/** Updates a ticket. */
export function updateTicket(payload: object): RequestOptionsFactory<any> {
  function __updateTicket({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'fields' }],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'checkoutForm.inputValues.number' },
          { path: 'checkoutForm.inputValues.address.address.geocode.latitude' },
          {
            path: 'checkoutForm.inputValues.address.address.geocode.longitude',
          },
          { path: 'guestDetails.form.inputValues.number' },
          {
            path: 'guestDetails.form.inputValues.address.address.geocode.latitude',
          },
          {
            path: 'guestDetails.form.inputValues.address.address.geocode.longitude',
          },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'checkoutForm.inputValues.dateTime' },
          { path: 'guestDetails.form.inputValues.dateTime' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket',
      method: 'PATCH' as any,
      methodFqn: 'wix.events.ticketing.TicketManagement.UpdateTicket',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingTicketManagementUrl({
        protoPath: '/v1/tickets/{ticketNumber}',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'ticket.checkIn.created' },
              { path: 'ticket.checkIn.checkInCanceledDate' },
              { path: 'ticket.guestDetails.form.inputValues.dateTime' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'ticket.guestDetails.form.inputValues.number' },
              {
                path: 'ticket.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'ticket.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __updateTicket;
}

/** Archives multiple tickets. */
export function bulkUpdateTickets(payload: object): RequestOptionsFactory<any> {
  function __bulkUpdateTickets({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.ticket',
      method: 'PATCH' as any,
      methodFqn: 'wix.events.ticketing.TicketManagement.BulkUpdateTickets',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsTicketingTicketManagementUrl({
        protoPath: '/v1/tickets',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'tickets.checkIn.created' },
              { path: 'tickets.checkIn.checkInCanceledDate' },
              { path: 'tickets.guestDetails.form.inputValues.dateTime' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'tickets.guestDetails.form.inputValues.number' },
              {
                path: 'tickets.guestDetails.form.inputValues.address.address.geocode.latitude',
              },
              {
                path: 'tickets.guestDetails.form.inputValues.address.address.geocode.longitude',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkUpdateTickets;
}
